<template>
	<div class="net-returns-over-time-chart-value-item">
		<!-- color marker -->
		<div
			v-if="color && !hideItemIndicator"
			:class="{ 'py-25': stretch, 'py-50': !stretch }"
			data-test="item-indicator"
		>
			<span
				class="net-returns-over-time-chart-value-item-indicator"
				:class="{ stretch: stretch }"
				:style="{ backgroundColor: color }"
			></span>
		</div>
		<!-- content -->
		<div>
			<div :class="labelClasses" data-test="item-label">{{ label }}</div>
			<div :class="valueClasses" data-test="item-value">{{ formattedValue }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formattedPerformanceCurrencyValue } from '@utils/performance-portfolio';
interface Props {
	color?: string;
	label: string;
	value: string;
	stretch?: boolean;
	labelClasses?: string;
	valueClasses?: Array<string>;
	showPositiveChangeSign?: boolean;
	hideItemIndicator?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	stretch: false,
	labelClasses: '',
	color: '',
	valueClasses: () => [],
	showPositiveChangeSign: false,
	hideItemIndicator: false
});

const formattedValue = computed((): string => {
	return formattedPerformanceCurrencyValue(props.value, props.showPositiveChangeSign);
});
</script>

<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;
@use '../../styles/constants/typography' as *;

.net-returns-over-time-chart-value-item {
	display: flex;
	gap: 8px;

	.net-returns-over-time-chart-value-item-indicator {
		display: block;
		width: 8px;
		height: 8px;
		border-radius: 50%;

		&.stretch {
			height: 100%;
			border-radius: 20px;
		}
	}
}
</style>
